import { ObjectRule } from '@/classes/rules/ObjectRule';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';
import { EnumRule } from '@/classes/rules/EnumRule';
import { BatteryTypeRef } from '@/dto/scenario/battery/BatteryReference';
import { ScenarioBatteryExt } from '@/classes/scenario/battery/ScenarioBatteryExt';
import { OptionsRule } from '@/classes/rules/OptionsRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { BooleanRule } from '@/classes/rules/BooleanRule';
import { SizingAlgorithmRef } from '@/dto/scenario/sizing/SizingReference';

// HOURS OPTIONS
const hoursOptions: number[] = [];
for (let i = 0; i <= 24; i++) {
  hoursOptions.push(i);
}

const hours23Options: number[] = [];
for (let i = 0; i < 24; i++) {
  hours23Options.push(i);
}

// BATTERY RULES =========================================================
export const buildBatteryRules = () => new ObjectRule<ScenarioBatteryExt>('battery', [

  new EnumRule('typeRef', BatteryTypeRef),

  new BooleanRule('isGridForming')
    .withIsAvailable(scenario => scenario.isMultigenset()),

  new MinMaxRule('invertersLifetimeYear', 0, 100, 'years')
    .withDefaultValue(() => new DefaultValue(15).withLock()),

  new OptionsRule('fromHour', hours23Options)
    .withDefaultValue(() => new DefaultValue(0).withLock()),

  new OptionsRule('toHour', hoursOptions)
    .withDefaultValue(() => new DefaultValue(24).withLock()),

  new MinMaxRule('socMinPercentage', 0, 1, '%')
    .withFactor(100)
    .withDefaultValue(() => new DefaultValue(0.1)),

  new MinMaxRule('globalSocMaxPercentage', 0, 1, '%')
    .withFactor(100)
    .withDefaultValue(() => new DefaultValue(0.9)),

  new BooleanRule('isRechargeableByGrid')
    .withDefaultValue(() => new DefaultValue(true))
    .withIsAvailable(scenario => (scenario.hasBattery && scenario.hasGrid && scenario.sizing &&
      (scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_v3_hybrid ||
        scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_multi_genset)) || false
    ),

  new MinMaxRule('socMaxChargeGrid', 0, 1, '%')
    .withFactor(100)
    .withDefaultValue(() => new DefaultValue(0.7))
    .withIsAvailable(scenario =>
      (scenario.hasBattery && scenario.hasGrid && scenario.battery && scenario.battery.isRechargeableByGrid && scenario.sizing &&
        (scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_v3_hybrid ||
          scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_multi_genset)) || false
    ),

  new BooleanRule('isRechargeableByGenerator')
    .withDefaultValue(() => new DefaultValue(true))
    .withIsAvailable(scenario =>
      (scenario.hasBattery && scenario.hasGenset && scenario.sizing &&
        (scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_v3_hybrid ||
          scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_multi_genset)) || false
    ),

  new MinMaxRule('socMaxChargeGen', 0, 1, '%')
    .withFactor(100)
    .withDefaultValue(() => new DefaultValue(0.6))
    .withIsAvailable(scenario =>
      (scenario.hasBattery && scenario.hasGenset && scenario.battery && scenario.battery.isRechargeableByGenerator && scenario.sizing &&
        (scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_v3_hybrid ||
          scenario.sizing.algorithmRef === SizingAlgorithmRef.algo_multi_genset)) || false
    ),

  new MinMaxRule('socToleranceGridForming', 0, 1, '%')
    .withFactor(100)
    .withDefaultValue(() => new DefaultValue(0.01)),

  new MinMaxRule('chargeEfficiencyPercentage', 0, 1, '%')
    .withFactor(100),

  new MinMaxRule('dischargeEfficiencyPercentage', 0, 1, '%')
    .withFactor(100),

  new MinMaxRule('cRate', 0, 100),

  new MinMaxRule('lifetimeCycles', 0, 10000, 'cycle')
]).withDefaultValue(() => new DefaultValue(new ScenarioBatteryExt()))
  .withIsAvailable(scenario => scenario.hasBattery || false);
